module.exports = __webpack_public_path__ + "media/27.9138937a.mp3";